var React = require('react');

function LocationPin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#97a6aa;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("g",{"transform":"translate(-2)","key":1},React.createElement("g",{"transform":"translate(2.5 0.5)"},[React.createElement("path",{"className":"a","d":"M14.5,6.833c0,4.667-6,9-6,9s-6-4.333-6-9A6.058,6.058,0,0,1,8.5.5,6.058,6.058,0,0,1,14.5,6.833Z","transform":"translate(-2.5 -0.5)","key":0}),React.createElement("circle",{"className":"a","cx":"3","cy":"3","r":"3","transform":"translate(3 3.167)","key":1})]))]);
}

LocationPin.defaultProps = {"width":"13","height":"16.333","viewBox":"0 0 13 16.333"};

module.exports = LocationPin;

LocationPin.default = LocationPin;
